import React from 'react';
import { Clock, LogOut } from 'lucide-react';
import { Card, Button } from '@/components/ui';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Full-screen interstitial shown when the active org is awaiting super-admin
 * approval (free-trial vetting). Blocks the app until approved/rejected.
 */
export function RegistrationPendingScreen() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card padding="lg" className="max-w-md w-full flex flex-col items-center text-center gap-4">
        <div className="w-12 h-12 rounded-full bg-status-pending-bg flex items-center justify-center">
          <Clock className="w-6 h-6 text-status-pending" />
        </div>
        <h1 className="text-h2 font-semibold text-foreground">Registration pending review</h1>
        <p className="text-sm text-muted-foreground">
          Thanks for signing up. A SimCheck administrator is reviewing your registration — you&apos;ll get an
          email as soon as your trial is approved, with a link to set your password and start testing.
        </p>
        <Button variant="outline" size="sm" onClick={() => logout()}>
          <LogOut className="w-4 h-4 mr-1.5" />
          Sign out
        </Button>
      </Card>
    </div>
  );
}
